import React, { useState } from "react";
import {
  List,
  useTable,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";
import useCheckEnvironment from "components/hook/useCheckEnvironment";

export const TXHistoryList = () => {
  const checkEnvironment = useCheckEnvironment();
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const handleDetail = (hash: string) => {
    if (!!hash && hash !== "") {
      if (checkEnvironment) {
        switch (checkEnvironment) {
          case "PROD":
            window.open(`https://tronscan.org/#/transaction/${hash}`, "_blank");
            break;
          default:
            window.open(
              `https://nile.tronscan.org/#/transaction/${hash}`,
              "_blank"
            );
            break;
        }
      }
    }
  };
  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "user_id",
        title: "User Id",
        type: "number",
        width: 80,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "user_email",
        title: "Email",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "user_name",
        title: "Name",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "user_wallet_addr",
        title: "Wallet Address",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "result",
        title: "Result",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "amount",
        title: "Amount",
        width: 80,
        type: "number",
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "timestamp",
        title: "Time Stamp",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "transaction_hash",
        title: "Transaction Hash",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "detail",
        title: "Detail",
        render: (_, record) => {
          return (
            <>
              <Button
                type="primary"
                onClick={() => {
                  handleDetail(record.transaction_hash);
                }}
              >
                Detail
              </Button>
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        width: 80,
        fixed: "right",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
